import { Building2, Search, Share2, UserPlus } from 'lucide-react';
import type { FeatureContent } from './types';

export const collaborazione: FeatureContent = {
  slug: 'collaborazione',
  navLabel: 'Collaborazione',
  menuDescription:
    'Condividi conversazioni con colleghi o team e gestisci accessi e ruoli nell’area di lavoro.',
  cardDescription:
    'Condividi conversazioni con colleghi o con tutto il team e gestisci accessi e ruoli nell’area di lavoro.',
  meta: {
    title: 'Collaborazione: un’area di lavoro per tutto lo studio',
    description:
      'Porta colleghi e collaboratori nella stessa area di lavoro: conversazioni private o condivise, storico comune ricercabile e ruoli amministratore e standard, senza costi per gli utenti aggiuntivi.',
  },
  hero: {
    title: 'Collaborazione',
    subtitle:
      'Porta colleghi e collaboratori nella stessa area di lavoro. Condividi le conversazioni quando serve, mantieni private quelle riservate e ritrova ricerche, risposte e documenti già prodotti dal team.',
  },
  statement: 'Il lavoro fatto una volta può servire a tutto il team',
  statementText:
    'Una ricerca, un quesito o un documento non devono restare nella cartella di chi li ha prodotti: quando scegli di condividerli, diventano patrimonio di lavoro dello studio.',
  blocks: [
    {
      icon: Building2,
      kicker: 'Area di lavoro',
      title: 'Un unico spazio per lavorare insieme',
      description:
        'Colleghi e collaboratori accedono con il proprio account alla stessa area di lavoro, dove ritrovano conversazioni, documenti e impostazioni condivise secondo la visibilità scelta.',
    },
    {
      icon: Share2,
      kicker: 'Condivisione',
      title: 'Decidi chi può vedere ogni conversazione',
      description:
        'Mantienila privata, condividila con colleghi specifici oppure rendila disponibile a tutto il team. Puoi anche impostare una modalità predefinita per le nuove conversazioni e cambiarla caso per caso.',
    },
    {
      icon: Search,
      kicker: 'Storico condiviso',
      title: 'Ritrova il lavoro già fatto',
      description:
        'Cerca nello storico per titolo o contenuto e filtra le conversazioni in base a chi le ha create, così puoi recuperare rapidamente analisi e materiali già disponibili nell’area di lavoro.',
    },
    {
      icon: UserPlus,
      kicker: 'Utenti e ruoli',
      title: 'Ognuno entra con il proprio ruolo',
      description:
        'Invita nuovi collaboratori e assegna loro un profilo Amministratore o Standard, distinguendo chi gestisce l’area di lavoro da chi la utilizza nel lavoro quotidiano. Invitare collaboratori non comporta costi aggiuntivi.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Crea l’area di lavoro',
      description: 'Imposta lo spazio dello studio o dell’organizzazione da cui partire.',
    },
    {
      step: 2,
      title: 'Invita il team',
      description:
        'Aggiungi colleghi e collaboratori con il loro account personale e assegna il ruolo corretto.',
    },
    {
      step: 3,
      title: 'Scegli cosa condividere',
      description:
        'Decidi se le nuove conversazioni devono restare private, essere condivise con persone specifiche o diventare visibili a tutto il team.',
    },
  ],
  relatedSolutions: ['studi-legali', 'avvocati', 'aziende'],
  closing: {
    title: 'Porta Trovanorma nel lavoro di tutto il team',
    text: 'Crea l’area di lavoro, invita i colleghi e prova a condividere ricerche, conversazioni e documenti mantenendo il controllo su chi può accedere.',
  },
};
